<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { selectedGroup } from '../store';
    import http from '../api/http.js';
    import {Button, Modal, ModalBody, ModalFooter, ModalHeader, CustomInput } from 'sveltestrap';
    let shown =false;
    const dispatch = createEventDispatcher();
    const toggle = () => (shown = !shown);
    let software;
   
    export async function show(softwareArg) {
        software = softwareArg;
        shown = true;
    }

    async function deleteSoftware() {
        const res = await http.delete(window.apiBaseUrl + `/deploy/dashboard/software/${software.id}/${$selectedGroup}`);
        if (res.ok) {
            dispatch('softwareDeleted');
            shown = false;
        }
    }

    function _onYes() {  
        deleteSoftware();
        shown = false;
    }    
   
    function _onNo() {
        shown = false;
    }
   </script>
   
   <Modal isOpen={shown} {toggle}>
       <ModalHeader {toggle}>
           Delete Version
       </ModalHeader>
       <ModalBody>
           <p>Are you sure you want to delete <strong class="text-info">{software.name}</strong>?</p>
           <p class="text-danger"><i class="fa fa-exclamation-triangle"></i> This action is <strong>Permanent</strong> and cannot be undone are you sure you wish to continue?</p> 
       </ModalBody>
       <ModalFooter>
            <button id="delete-software-cancel-button" class="btn btn-outline-primary" on:click={() => _onNo()}>Cancel</button>
           <button id="delete-software-confirm-button" on:click={() => _onYes()} class="btn btn-primary">Confirm</button>
       </ModalFooter>
    </Modal>
